import { Box, Text, TextProps } from '@jfs/ui-new'
import { FC } from 'react'
import { Clipboard } from 'react-native'
import { isStringBlank } from '../../util/util'
import { styles } from './styles'

interface CopyViewProps {
  entry: any
  statusStyle?: TextProps
  textStyles: TextProps
  isHovering: boolean
  copied: boolean
  setCopied: any
}
const CopyView: FC<CopyViewProps> = ({
  entry,
  statusStyle,
  textStyles,
  isHovering,
  copied,
  setCopied,
}: CopyViewProps) => {
  const handleOnCopy = () => {
    Clipboard.setString(entry.value)
    setCopied && setCopied(true)
  }
  const viewStyle = copied ? styles.copiedStyle : styles.copyStyle
  const textStyle = copied ? styles.copiedTxtStyle : styles.copyTxtStyle
  return (
    <>
      <Text {...textStyles} {...statusStyle}>
        {isStringBlank(entry.value) ? 'NA' : entry.value}
      </Text>
      {isHovering && entry.id === 'url' && (
        <Box
          {...viewStyle}
          testID="handleOnCopy"
          accessibilityLabel={copied ? 'Copied' : 'Copy'}
          onPress={handleOnCopy}
          marginLeft={4}>
          <Text {...textStyle}>{copied ? 'Copied' : 'Copy'}</Text>
        </Box>
      )}
    </>
  )
}

export { CopyView }
